import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionMenuService } from 'src/app/components/shared/sharedModules/permission/permission-menu.service';
import { UserDataService } from 'src/app/components/shared/sharedServices/user-data.service';

@Component({
  selector: 'app-layout-main',
  templateUrl: './layout-main.component.html',
  styleUrls: ['./layout-main.component.sass'],
})
export class LayoutMainComponent implements OnInit {
  private router: Router;
  private permissionMenuService: PermissionMenuService;

  constructor(private injector: Injector, private userDataService: UserDataService) {
    this.router = this.injector.get<Router>(Router);
    this.permissionMenuService = this.injector.get<PermissionMenuService>(PermissionMenuService);
  }

  async ngOnInit(): Promise<void> {
    await this.initData();
  }

  /**
   * init data
   */
  async initData(): Promise<void> {
    this.userDataService?.setTokenLocalInStorage();
    this.userDataService?.setUserDataInStorage();
    if (this.router.url === '/') {
      const redirect = await this.permissionMenuService.getRedirectByPermission();
      this.router.navigate([redirect]);
    }
  }
}
